import { render, staticRenderFns } from "./KnowledgeAreaBox.vue?vue&type=template&id=77117665&"
import script from "./KnowledgeAreaBox.vue?vue&type=script&lang=js&"
export * from "./KnowledgeAreaBox.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeAreaBox.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports